module.exports = __webpack_public_path__ + "static/media/85.62217903.png";